import * as HLF from "html-living-framework";
import { NumberUtils } from "html-living-framework";
import { Emitter } from "pixi-particles";
import * as Constants from "../Data/Constants";
import { Culture } from "../Data/Culture";

export class NoteParticleSystem extends PIXI.Container {
    protected _emitter!: Emitter;

    constructor(pCulture: Culture) {
        super();
    }

    public updateFromGame(pDeltaTime: number): void {
        this._emitter.update(pDeltaTime);
    }

    public startEmitting(pCulture: Culture): void {
        this.culture = pCulture;
        this._emitter.emit = true;
    }

    public stopEmitting(): void {
        this._emitter.emit = false;
    }

    public updateSpawnPosition(pPoint: PIXI.Point): void {
        this._emitter.updateSpawnPos(pPoint.x, pPoint.y);
    }

    public set culture(pCulture: Culture) {
        this._emitter.particleImages = this.getTexturesForCulture(pCulture);
    }

    protected getTexturesForCulture(pCulture: Culture): PIXI.Texture[] {
        const cultureAsString = NumberUtils.addZeroPadding(pCulture, 2);

        // two shapes, three colours per country
        return [
            HLF.PixiUtils.getTexture("music-note-00-" + cultureAsString + "-00", Constants.SPRITESHEET_NOTE_PARTICLES),
            HLF.PixiUtils.getTexture("music-note-00-" + cultureAsString + "-01", Constants.SPRITESHEET_NOTE_PARTICLES),
            HLF.PixiUtils.getTexture("music-note-00-" + cultureAsString + "-02", Constants.SPRITESHEET_NOTE_PARTICLES),
            HLF.PixiUtils.getTexture("music-note-01-" + cultureAsString + "-00", Constants.SPRITESHEET_NOTE_PARTICLES),
            HLF.PixiUtils.getTexture("music-note-01-" + cultureAsString + "-01", Constants.SPRITESHEET_NOTE_PARTICLES),
            HLF.PixiUtils.getTexture("music-note-01-" + cultureAsString + "-02", Constants.SPRITESHEET_NOTE_PARTICLES),
        ];
    }
}
